import React from 'react'

const ContactSkeleton = () => {
  return (
   <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
  {[...Array(6)].map((_, index) => (
    <div
      key={index}
      className="mb-4 flex max-w-sm flex-col justify-between rounded-lg bg-white text-center shadow-md animate-pulse"
    >
      
      <div className="relative h-40 overflow-hidden px-5 pb-10 pt-5 text-center">
        <div className="h-20 w-full rounded bg-gray-200"></div>
        <div className="absolute bottom-3 right-3 h-10 w-10 rounded-full bg-gray-300"></div>
      </div>
      
      <div className="mt-4 rounded-tl-3xl bg-gradient-to-br from-gray-200 via-gray-300 to-gray-200 py-4">
        <div className="mx-auto mb-2 h-5 w-32 rounded bg-gray-300"></div>
        <div className="mx-auto mb-1 h-4 w-24 rounded bg-gray-300"></div>
        <div className="mx-auto h-4 w-28 rounded bg-gray-300"></div>
      </div>
    </div>
  ))}
</div>

  )
}

export default ContactSkeleton